import { useEffect } from 'react'
import AuthService from '../services/auth.service'
import { isNullOrUndefined } from '../common/Helpers'
import { login } from '../actions/auth-action'

const useSendForgotPasswordCode = (loginModel, setForgotPassModel, fireSendCode, setFireSendCode) => {
    useEffect(() => {
        const doIt = async () => {
            try {
                const domain = loginModel.clientUserListAccess.find(x => x.selected === true).userName.split('\\')[0];
                const username = loginModel.clientUserListAccess.find(x => x.selected === true).userName.split('\\')[1];
                const serviceResponse = await AuthService.forgotPassword(domain, username, loginModel.email, loginModel.email, localStorage.getItem("i18nextLng"));
                const response = serviceResponse.data;

                setForgotPassModel && setForgotPassModel(prevState => ({
                    ...prevState,
                    codeSended: response.succeeded ? true : false,
                    email: loginModel.email,
                    emailConfirmation: loginModel.email,
                    domain: domain,
                    username: username,
                }));
            }
            catch (error) {

            }
        }

        if (loginModel !== null && fireSendCode === true) {
            setFireSendCode && setFireSendCode(false)
            doIt()
        }

    }, [loginModel, setForgotPassModel, fireSendCode, setFireSendCode])
}


export {
    useSendForgotPasswordCode,
}
